import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { SET_UI_MODE } from '../../http/apollo-queries';
import { Loading, Icon } from '../../components/UI';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/Auth';
import { toast } from 'react-toastify';
import { Modal } from '../../components/Modal';
import { useMobile } from '../../context/Mobile';
import { logger } from '../../helpers/logger';

const ChooseTheme = () => {
  const { user, refetch } = useAuth();
  const { dispatch } = useMobile();

  const [chosenTheme, setChosenTheme] = useState<string>('LIGHT');
  const [setUIMode, { loading }] = useMutation(SET_UI_MODE, {
    onCompleted: (data) => {
      refetch().then(() => {
        dispatch({ mobileSignupCompleted: true });
        navigate('/strategies');
      });
    },
    onError: (err) => {
      logger.error(err);
      toast.error(t('chooseTheme.error'));
    },
  });
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setChosenTheme(user?.uiMode === 'DARK' ? 'DARK' : 'LIGHT');
  }, [user]);

  const uiModes = ['LIGHT', 'DARK'];

  return (
    <Modal
      isOpen={true}
      padding={'base'}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      className={'justify-center text-center items-center'}
    >
      <div className={'text-center'}>
        <h1 className={'text-black text-xl font-semibold mb-4 dark:text-white'}>
          {t('chooseTheme.title')}
        </h1>
        <p className={'text-grey-50 text-sm whitespace-pre-wrap'}>
          {t('chooseTheme.subtitle')}
        </p>
        <div className={'flex flex-col items-center mt-8'}>
          {uiModes.map((mode, index) => {
            return (
              <div
                key={mode}
                className={`w-80 w-12 mt-4 cursor-pointer duration-300 transition-colors flex items-center rounded-3xl hover:bg-lime
              ${loading ? 'pointer-events-none' : ''}
              ${
                chosenTheme === mode
                  ? 'bg-primary dark:bg-lime dark:text-black'
                  : 'bg-grey-10 dark:text-white'
              }
          `}
                onClick={() => {
                  setChosenTheme(mode);
                  setUIMode({
                    variables: {
                      mode,
                    },
                  });
                }}
              >
                <div className="w-12 h-12 rounded-full bg-black flex justify-center items-center">
                  <Icon
                    className="text-primary"
                    color="primary"
                    svgName={mode === 'LIGHT' ? 'light' : 'dark'}
                  />
                </div>
                <span className="ml-4 text-black font-semibold">
                  {t(
                    mode === 'LIGHT'
                      ? 'chooseTheme.lightMode'
                      : 'chooseTheme.darkMode'
                  )}
                </span>
                <Loading
                  className="ml-4"
                  status={loading && chosenTheme === mode}
                  size="small"
                />
                <Icon
                  className="ml-auto mr-1 w-8"
                  color="black"
                  svgName={'chevronRight'}
                />
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

export default ChooseTheme;
